import * as React from 'react';
import { DemandBannerContainer } from '../../../DemandBanner';
import { PublicationContainer } from '../../../Publication';
import { PromotionContainer } from '../../../Promotion';
import { MessageWrapper } from '../../../Messages';
import { SummaryContainer } from '../../../Summary';

export const ServicePickerWidgetContent = () => {
  return (
    <>
      <DemandBannerContainer />
      <PublicationContainer />
      <PromotionContainer />
      <MessageWrapper />
      <SummaryContainer />
    </>
  );
};
